export function normalizeAuthReturnPath(
  returnTo: string | null | undefined,
  fallback = "/",
) {
  if (!returnTo?.startsWith("/") || returnTo.startsWith("//")) {
    return fallback;
  }

  return returnTo;
}

export function buildAuthCallbackURL(
  returnTo: string | null | undefined,
  baseURL: string,
  fallback = "/",
) {
  const returnPath = normalizeAuthReturnPath(returnTo, fallback);

  try {
    return new URL(returnPath, baseURL).href;
  } catch {
    return new URL(fallback, baseURL).href;
  }
}
